import { h } from 'preact'

export const BandeMentionsLegales = (props) => {
   const { title, description, notes, cacheKey } = props
   return (
      <div id="zone_legal_notices" class="bg-gray2 legal-notices" data-testid="bande-mentions-legales" data-cache-key={cacheKey}>
         <div class="container-fluid">
            <div class="row no-gutters py-1 text-black">
               <div class="col-12">
                  {title !== '' ? <h2 class="lead font-weight-bold no-signature mb-0">{title}</h2> : ''}
                  {title !== '' && description !== '' ? <span class="small font-weight-bold d-block">{description}</span> : ''}

                  <ul class="m-0">
                     {notes.map((note) => {
                        return (
                           <li class="small">
                              <strong>{note.title}</strong>
                              {note.description !== '' ? <span> : {note.description}</span> : ''}
                           </li>
                        )
                     })}
                  </ul>
               </div>
            </div>
         </div>
      </div>
   )
}
